import { BROWSER_LANGUAGE, ECHART_COLOR } from '@gp/constants/const';

import type { AxisPointerOption } from 'echarts/types/dist/shared';

// 图例组件高度
export const LEGEND_COMP_HEIGHT = 14;
// 图例组件与Grid的间距（纵向）
export const LEGEND_GRID_SPACING = 20;

// 文本配置
const TEXT_CFG = {
  LINE_HEIGHT: 14,
  FONT_STYLE: 'normal',
  FONT_WEIGHT: 'normal',
  FONT_SIZE: 12,
  COLOR: '#838697',
};

// 边框配置
const BORDER_CFG = {
  STYLE: 'solid',
  WIDTH: 1,
  COLOR: '#D8DAE4',
};

// 字体样式（汇总）
const TEXT_STYLES = {
  lineHeight: TEXT_CFG.LINE_HEIGHT,
  fontWeight: TEXT_CFG.FONT_WEIGHT as any,
  fontStyle: TEXT_CFG.FONT_STYLE as any,
  fontSize: TEXT_CFG.FONT_SIZE,
  color: TEXT_CFG.COLOR,
};

// 柱状图serie基础配置
const BASE_BAR_SERIES_OPTION: IBarSeriesOption = {
  type: 'bar',
  barMaxWidth: 58,
  label: {
    ...TEXT_STYLES,
    // 默认不展示
    show: false,
    position: 'top',
    distance: 5,
    fontFamily: 'PingFang SC',
    color: '#000',
  },
};

// REMARK: 定义echarts折线图 线的 基础通用配置
const BASE_LINE_SERIES_OPTION: ILineSeriesOption = {
  type: 'line',
};

// 矩形贴花配置
const PRIMARY_RECT_DECAL_OPTIONS = {
  symbol: 'rect',
  color: 'rgba(255, 255, 255, 1)',
  dashArrayX: [4, 16],
  dashArrayY: [1, 0],
  rotation: 45,
};

// 圆形贴花配置
const PRIMARY_CIRCLE_DECAL_OPTIONS = {
  symbol: 'circle',
  color: 'rgba(255, 255, 255, 0.12)',
  dashArrayX: [3, 3],
  dashArrayY: [3, 3],
};

const BASE_LINE_CHART_TOOLTIP_AXIS_POINTER_OPTION: AxisPointerOption = {
  type: 'line',
  lineStyle: {
    type: 'solid',
    color: '#C1C2CE',
  },
};

// 全局echarts图表公共配置
const BASE_ECHART_OPTION: IEChartOption = {
  color: ECHART_COLOR,
  backgroundColor: 'transparent',
  grid: {
    top: TEXT_CFG.FONT_SIZE,
    right: 0,
    bottom: LEGEND_COMP_HEIGHT + LEGEND_GRID_SPACING,
    // 浏览器英文环境下，left多2px，其余0
    left: BROWSER_LANGUAGE?.startsWith('en-') ? 2 : 0,
    containLabel: true,
  },
  tooltip: {
    borderWidth: 0,
    trigger: 'axis',
    className: 'echarts-tooltip-custom-style',
    axisPointer: {
      type: 'shadow',
      shadowStyle: {
        color: 'rgba(216, 218, 228, 0.5)',
      },
    },
    backgroundColor: 'rgba(255, 255, 255, 0)',
    confine: true,
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    axisLine: {
      lineStyle: {
        type: BORDER_CFG.STYLE as any,
        width: BORDER_CFG.WIDTH,
        color: BORDER_CFG.COLOR,
      },
    },
    axisLabel: {
      ...TEXT_STYLES,
      margin: 12,
    },
    axisTick: {
      alignWithLabel: true,
      lineStyle: {
        width: BORDER_CFG.WIDTH,
        color: BORDER_CFG.COLOR,
      },
    },
    data: [],
  },
  yAxis: [
    {
      type: 'value',
      axisLine: {},
      axisLabel: {
        ...TEXT_STYLES,
      },
      splitLine: {
        // 分割线设置
        lineStyle: {
          type: 'dashed',
          width: BORDER_CFG.WIDTH,
          color: BORDER_CFG.COLOR,
        },
      },
    },
  ],
  legend: {
    orient: 'horizontal', // 横向
    bottom: 0,
    padding: [0, 0, 0, 0],
    height: LEGEND_COMP_HEIGHT,
    type: 'scroll',
    icon: 'circle', // 修改icon形状
    itemGap: 20, // 修改每个图例的间距
    itemWidth: 8, // 修改icon图形大小
    itemHeight: 8,
    itemStyle: {
      borderWidth: 0, // icon圆点的边框线宽度
    },
    inactiveBorderColor: '#fff',
    inactiveBorderWidth: 0, // 图例关闭时icon圆点的描边粗细
    inactiveColor: '#ccc',
    textStyle: {
      ...TEXT_STYLES,
    },
    pageIconSize: 12,
    pageIconColor: '#000', // 翻页箭头颜色
    pageTextStyle: {
      color: '#000', // 翻页数字颜色
    }, // 翻页数字设置
  },
  series: [],
  dataset: {
    dimensions: [],
    source: [],
  },
};

// grid的top值（有y轴name配置时（货币美元））
export const Y_AXIS_NAME_CURRENCY_GRID_TOP = 45;

// grid的配置（有y轴name配置时（货币美元））
export const Y_AXIS_NAME_CURRENCY_GRID_OPTION = {
  top: Y_AXIS_NAME_CURRENCY_GRID_TOP,
};

// y轴name配置（货币美元）
export const Y_AXIS_NAME_CURRENCY_OPTION = {
  name: '($)',
  nameLocation: 'end',
  nameGap: 20,
  nameTextStyle: {
    padding: [0, 30, 0, 0],
    fontSize: 12,
  },
};

export {
  ECHART_COLOR,
  BASE_BAR_SERIES_OPTION,
  BASE_LINE_SERIES_OPTION,
  PRIMARY_RECT_DECAL_OPTIONS,
  PRIMARY_CIRCLE_DECAL_OPTIONS,
  BASE_LINE_CHART_TOOLTIP_AXIS_POINTER_OPTION,
  BASE_ECHART_OPTION,
};
